import styled from '@emotion/styled';
import { IconButton } from '../icon-button/IconButton';
import { shouldForwardProps } from '../../../utils';

export const StyledArrowButton = styled(IconButton, shouldForwardProps)`
    background-color: ${({ theme }) => theme.colors.surface};
    border-radius: 12px;
    :hover {
        background-color: ${({ theme }) => theme.colors.fadedPrimaryContainer};
    }
`;
